import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getUserColors, getUserInitials } from '../../utils/colorUtils';

interface ProfileAvatarProps {
  userProfile: {
    userId: string;
    displayName?: string;
    firstName?: string;
    email?: string;
  };
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ userProfile }) => {
  const location = useLocation();
  const isActive = location.pathname === `/u/${userProfile.userId}`;

  // Get user colors and initials for profile picture
  const userName = userProfile?.displayName || userProfile?.firstName || userProfile?.email || 'User';
  const userColors = getUserColors(userName);
  const userInitials = getUserInitials(userName);

  return (
    <Link
      to={`/u/${userProfile.userId}`}
      className={`group relative hover:scale-105 transition-transform duration-200 mr-4 sm:mr-0 sm:mb-3 ${
        isActive ? 'scale-105' : ''
      }`}
    >
      <div className={`w-6 h-6 rounded-full overflow-hidden shadow-lg ring-2 transition-all duration-200 ${
        isActive
          ? 'ring-white/60'
          : 'ring-white/20 group-hover:ring-white/40'
      }`}>
        <div
          className="w-full h-full flex items-center justify-center"
          style={{
            background: `linear-gradient(135deg, ${userColors.primary}, ${userColors.secondary})`
          }}
        >
          <span className="text-white text-xs font-bold">
            {userInitials}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProfileAvatar;